import { MemberLanguages } from "./member-languages";

export class InterpretiveService {
    public LanguageRequested: MemberLanguages;
    public Notes: string;
    public IsUrgentPriority: boolean;
}
